import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { useNavigate, useParams } from 'react-router-dom';
import { Column } from 'primereact/column';
import { Grid } from '@mui/material';
import { IAccessPoint } from '../../types/location/location';

interface IAccessPointTableProps {
  data: IAccessPoint[];
  selectedAccessPoint: any[];
  setSelectedAccessPoint: any;
}

export const AccessPointTable = ({
  data,
  setSelectedAccessPoint,
  selectedAccessPoint
}: IAccessPointTableProps) => {
  const { locationId } = useParams();
  const navigate = useNavigate();
  const redirectToDeviceToLocation = (rowData: IAccessPoint) => {
    if (rowData.controllerCount > 0) {
      return (
        <Button
          severity="info"
          text
          label={`${rowData.controllerCount} Devices`}
          onClick={() => {
            navigate(
              `/locations/${locationId}/devices?accessPointId=${rowData.locationAccessPointId}&ssidName=${rowData.ssidName}`
            );
          }}
        />
      );
    }
    return rowData.controllerCount;
  };

  const getDate = (item: IAccessPoint) => {
    if (!item.createdAt || item.createdAt === '0001-01-01T00:00:00') {
      return (
        <Grid container justifyContent="center" alignItems="center">
          <span>No Data</span>
        </Grid>
      );
    }

    const date = new Date(item.createdAt);

    const formattedDate = date.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });

    return (
      <Grid container justifyContent="center" alignItems="center">
        <span>{formattedDate}</span>
      </Grid>
    );
  };

  return (
    <DataTable
      selection={selectedAccessPoint}
      onSelectionChange={(e) => setSelectedAccessPoint(e.value)}
      value={data}
      size="small"
      scrollHeight="flex"
      scrollable
      selectionMode="multiple"
      paginator={data && data.length >= 50}
      selectionPageOnly
      rows={50}
      rowsPerPageOptions={[5, 10, 25, data ? data.length : 50]}
      tableStyle={{ fontSize: '14px' }}
    >
      <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
      <Column field="createdAt" header="Date Created" sortable body={getDate} />
      <Column field="ssidName" header="Name" sortable />
      <Column field="ssidPassword" header="Password" sortable />
      <Column field="accessPointMAC" header="MAC" sortable />
      <Column
        field="controllerCount"
        header="Controller Count"
        sortable
        body={redirectToDeviceToLocation}
      />
    </DataTable>
  );
};
